import { Button, Colors, Icon } from "@blueprintjs/core";
import { Header } from "@package/ui-header";

type AppHeaderProps = {
  isFullWidth?: boolean;
  onFullWidthChanegd?: (full: boolean) => void;
};

export function AppHeader({
  isFullWidth = false,
  onFullWidthChanegd,
}: AppHeaderProps) {
  return (
    <Header fullWidth={isFullWidth}>
      <Button
        minimal
        title={isFullWidth ? "Narrow Layout" : "Full Screen"}
        onClick={() => onFullWidthChanegd?.(!isFullWidth)}
      >
        <Icon
          icon={isFullWidth ? "minimize" : "maximize"}
          style={{ color: Colors.WHITE }}
        />
      </Button>
    </Header>
  );
}
